const isProduction = () => window.location.origin === process.env.REACT_APP_PROD_URL;
export default isProduction;
